import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import LabelText from '../LabelText';
import PanelInputField from '../PanelInputField';

import ArtStyleSlider from './ArtStyleSlider';

interface Props {}

const ArtStyleField: React.FC<Props> = () => {
  const { t } = useTranslation('dreamup');
  const groupLabelId = useId();

  return (
    <PanelInputField
      rootTag="div"
      role="radiogroup"
      aria-labelledby={groupLabelId}
      label={
        <LabelText id={groupLabelId}>{t('dreamup.header.settingsPanel.artStyle.label')}</LabelText>
      }
      input={<ArtStyleSlider />}
    />
  );
};

ArtStyleField.displayName = 'ArtStyleField';

export default ArtStyleField;
